export default "__VITE_ASSET__0064a032__"